<template>
  <v-app class="vue-app">
    <v-main
      class="container-pai"
      style="max-height: 99.5vh"
      :style="
        layout.executandoAcao || layout.isSidebarOpen ? 'overflow: hidden;' : ''
      "
    >
      <Loadingfs v-show="layout.loading"> </Loadingfs>
      <router-view></router-view>
      <VNotifierContainer toast.location="bottom"/>

      <div
        class="aviso-procedimento no-print"
        :class="(fechandoAviso)?'slide-out-tl':''"
      >
        <div class="aviso-content">
          <v-icon class="aviso-icon" color="white"
            >mdi-information-outline</v-icon
          >
          <div class="aviso-texto">
            <h4>Precisa de ajuda?</h4>
            <p>
              Clique
              <a
                href="https://sindustrial.atlassian.net/servicedesk/customer/portal/1"
                target="_blank"
              >
                AQUI</a
              >
              para acessar o
              <a
                href="https://sindustrial.atlassian.net/servicedesk/customer/portal/1"
                target="_blank"
                >Sistema de abertura de ticket</a
              >
              e falar com um desenvolvedor sobre um
              <a
                class="normal"
                href="https://sindustrial.atlassian.net/servicedesk/customer/portal/1/group/6/create/5"
                target="_blank"
                >bug ou melhoria.</a
              >
            </p>
          </div>
          <v-btn
            icon="mdi-close"
            size="x-small"
            class="aviso-close"
            @click="fecharAviso"
          >
          </v-btn>
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import Loadingfs from "@/components/LoadingFullscreen.vue";
import layoutStore from "@/store/layout";
const layout: any = layoutStore();
// Verificar se versão do cache é a mesma do atual
import helperStore from "@/store/helpers";
import { useNotifier } from "vuetify-notifier";
const helper: any = helperStore();

const fechandoAviso = ref(false);
const mostrarAviso = ref(true);
onMounted(async () => {
  await helper.verificaVersaoCache();
});
function fecharAviso() {
  fechandoAviso.value = true;
  setTimeout(() => {
    mostrarAviso.value = false;
  }, 500);
}
</script>

<style lang="scss" scoped>
#loading {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.863);
}

.aviso-procedimento {
  position: fixed;
  bottom: 100px;
  right: 24px;
  max-width: 350px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  z-index: 15;
  animation: slide-in-br 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
.aviso-procedimento.slide-out-tl {
    // animation-direction: reverse;
    // animation-fill-mode: both;
  animation: slide-out-tl 1s ease-in-out both;

}


.aviso-content {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  color: white;
  position: relative;
}

.aviso-icon {
  margin-right: 12px;
  margin-top: 4px;
  font-size: 24px;
}

.aviso-texto {
  flex: 1;

  h4 {
    margin: 0 0 8px 0;
    font-size: 16px;
    font-weight: 600;
  }

  p {
    margin: 0;
    font-size: 14px;
    line-height: 1.4;
    opacity: 0.9;
  }
  a.normal {
    font-size: 14px;
  }
  a {
    color: white;
    font-weight: 700;
    font-size: 16px;
  }
}

.aviso-close {
  position: absolute;
  top: 6px;
  right: 6px;
  background: rgba(255, 255, 255, 0.2);

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
}

@keyframes slide-in-br {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-out-tl {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
}

@media (max-width: 480px) {
  .aviso-procedimento {
    right: 16px;
    left: 16px;
    max-width: none;
    bottom: 90px;
  }

  .aviso-content {
    padding: 12px;
  }

  .aviso-texto {
    h4 {
      font-size: 14px;
    }

    p {
      font-size: 13px;
    }
  }
}
</style>
